// extracted by mini-css-extract-plugin
export default {"emoji":"styles_emoji__ichyl","iconWrapper":"styles_iconWrapper__++ftr","icon":"styles_icon__HqAgH","emojiWrapper":"styles_emojiWrapper__SI3Jp"};